import { getApiErrorMessage } from '@/lib/api-error';
import { i18n } from '@/i18n';
import {
  dismissToast,
  pushToast,
  toastState,
  type ToastVariant,
} from '@/shared/feedback/toast-state';

type ToastOptions = {
  description?: string;
  duration?: number;
};

function show(variant: ToastVariant, message: string, options?: ToastOptions) {
  return pushToast({
    title: message,
    description: options?.description,
    duration: options?.duration,
    variant,
  });
}

export const toast = {
  success(message: string, options?: ToastOptions) {
    return show('success', message, options);
  },
  error(message: string, options?: ToastOptions) {
    return show('error', message, options);
  },
  warning(message: string, options?: ToastOptions) {
    return show('warning', message, options);
  },
  info(message: string, options?: ToastOptions) {
    return show('info', message, options);
  },
  fromError(error: unknown, fallback?: string) {
    return show(
      'error',
      getApiErrorMessage(error, fallback ?? i18n.global.t('errors.requestFailed')),
    );
  },
  dismiss: dismissToast,
};

export function useToast() {
  return toast;
}

export { toastState, dismissToast, pushToast } from '@/shared/feedback/toast-state';
